import {
  SET_DISPLAY_CONTENT,
  GET_DISCOUNTS,
  FILTER_DISCOUNTS,
  CLEAR_FILTERED_DISCOUNTS,
  SELECTED_DISCOUNT,
  FORM_DATA,
  FORM_ERROR,
  DISCOUNT_ERROR,
} from "../types";

const DiscountReducer = (state, action) => {
  switch (action.type) {
    case SET_DISPLAY_CONTENT:
      return { ...state, display_content: action.payload };

    case GET_DISCOUNTS:
      return { ...state, discounts: action.payload };

    case FILTER_DISCOUNTS:
      return {
        ...state,
        discounts_filtered: state.discounts.filter((discount) => {
          const regex = new RegExp(`${action.payload}`, "gi");
          return discount.discount_name.match(regex);
        }),
      };

    case CLEAR_FILTERED_DISCOUNTS:
      return { ...state, discounts_filtered: null };

    case SELECTED_DISCOUNT:
      return { ...state, selected_discount: action.payload };

    case FORM_DATA:
      return { ...state, form_data: action.payload };

    case FORM_ERROR:
      return { ...state, form_error: action.payload };

    case DISCOUNT_ERROR:
      return { ...state, discount_error: action.payload };

    default:
      return state;
  }
};

export default DiscountReducer;